const TRANSFORM_CDN_URL = process.env.REACT_APP_TRANSFORM_CDN_URL
  || 'https://d27snhiba7p64h.cloudfront.net';

const buildCdnUrl = (imagePath, { width, format, quality } = {}) => {
  const params = new URLSearchParams();

  if (width) params.append('width', width);
  if (format) params.append('format', format);
  if (quality) params.append('quality', quality);

  const path = imagePath.replace(/^\//, '');
  const query = params.toString();

  return query
    ? `${TRANSFORM_CDN_URL}/${path}?${query}`
    : `${TRANSFORM_CDN_URL}/${path}`;
};

export { buildCdnUrl }; // eslint-disable-line import/prefer-default-export
